module.exports = __webpack_public_path__ + "img/contract-flow@2x.0361bcd.png";